(function () {
  function getScrollStep(row) {
    const item = row.querySelector('.product-option__label--portrait:not(.active)')
      || row.querySelector('.product-option__label--portrait');
    if (!item) return 0;

    const gap = parseFloat(getComputedStyle(row).columnGap || getComputedStyle(row).gap) || 0;
    return item.offsetWidth + gap;
  }

  function updateNavState(row, prevButton, nextButton) {
    const maxScroll = Math.max(0, row.scrollWidth - row.clientWidth);
    const atStart = row.scrollLeft <= 1;
    const atEnd = row.scrollLeft >= maxScroll - 1;

    if (prevButton) {
      prevButton.disabled = atStart;
      prevButton.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }

    if (nextButton) {
      nextButton.disabled = atEnd;
      nextButton.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
    }
  }

  function initCarousel(carousel) {
    if (carousel.dataset.siblingsInit === 'true') return;

    const row = carousel.querySelector('.product__product-siblings-row');
    const prevButton = carousel.querySelector('.product__product-siblings-nav--prev');
    const nextButton = carousel.querySelector('.product__product-siblings-nav--next');

    if (!row || !prevButton || !nextButton) return;

    carousel.dataset.siblingsInit = 'true';

    const onScroll = () => updateNavState(row, prevButton, nextButton);

    prevButton.addEventListener('click', () => {
      row.scrollBy({ left: -getScrollStep(row), behavior: 'smooth' });
    });

    nextButton.addEventListener('click', () => {
      row.scrollBy({ left: getScrollStep(row), behavior: 'smooth' });
    });

    row.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    onScroll();
  }

  function initProductSiblingsCarousels(root = document) {
    root.querySelectorAll('.product__product-siblings-carousel--has-nav').forEach(initCarousel);
  }

  window.initProductSiblingsCarousels = initProductSiblingsCarousels;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductSiblingsCarousels());
  } else {
    initProductSiblingsCarousels();
  }
})();
